import ExitToAppOutlinedIcon from "@mui/icons-material/ExitToAppOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { Button, Container, InputAdornment, Stack, TextField } from "@mui/material";

import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Header, Step } from "../components";
import { ksefWebUrls } from "../consts";
import { useStore } from "../store";

export const TokenMethod = () => {
  const { t } = useTranslation();
  const { environment, applyToken } = useStore();
  const [token, setToken] = useState<string>();
  const [processing, setProcessing] = useState<boolean>(false);
  const [steps, setSteps] = useState<{ [key in number]: boolean }>({});
  const setStep = (step: number) => setSteps((s) => ({ ...s, [step]: true }));
  const iconSx = { fontSize: 36, color: "primary.main" } as const;

  const step1Done = steps[1];

  const onMoveToKSef = () => {
    window.open(ksefWebUrls[environment], "_blank");
    setStep(1);
  };

  const onConfirmToken = async () => {
    setProcessing(true);
    await applyToken(token || "");
    setProcessing(false);
  };

  return (
    <Container maxWidth="sm">
      <Stack spacing={4}>
        <Header titleLoc="tokenMethod.title" onBackPath="/" />

        <Stack spacing={1}>
          <Step
            step={1}
            titleLoc="tokenMethod.moveToKSef"
            description="tokenMethod.description"
            buttonLabelLoc="common.moveOn"
            replayLabelLoc="common.goAgain"
            done={step1Done}
            icon={<ExitToAppOutlinedIcon sx={iconSx} />}
            onClick={onMoveToKSef}
          />

          <Step
            step={2}
            titleLoc="tokenMethod.addToken"
            icon={<FileUploadOutlinedIcon sx={iconSx} />}
            buttonLabelLoc="common.add"
            showDone={false}
            done={steps[2]}
            disabled={!step1Done}
            onClick={() => setStep(2)}
          />

          {steps[2] && (
            <TextField
              disabled={processing}
              label="Token"
              variant="outlined"
              onChange={(e) => setToken(e.target.value)}
              autoComplete="off"
              error={(token?.length ?? 0) > 256}
              helperText={(token?.length ?? 0) > 256 ? t("tokenMethod.tokenTooLong") : undefined}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Button
                      loading={processing}
                      disabled={token === undefined || token === "" || (token?.length ?? 0) > 256}
                      onClick={onConfirmToken}
                      variant="contained"
                      style={{ borderRadius: 100 }}
                      disableElevation
                    >
                      {t("tokenMethod.confirmToken")}
                    </Button>
                  </InputAdornment>
                ),
              }}
            />
          )}
        </Stack>
      </Stack>
    </Container>
  );
};
